import { render, staticRenderFns } from "./TransactionsByPaymethod.vue?vue&type=template&id=f6a64ca0&scoped=true&"
import script from "./TransactionsByPaymethod.vue?vue&type=script&lang=js&"
export * from "./TransactionsByPaymethod.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsByPaymethod.vue?vue&type=style&index=0&id=f6a64ca0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a64ca0",
  null
  
)

export default component.exports